export default __webpack_public_path__ + "static/media/23.65a0d2c7.gif";